import InfoIcon from '@mui/icons-material/Info'
import { BannerSeverityProps } from './_props'
import sxs from './_sxs'

export const severityProps: BannerSeverityProps = {
    INFO: {
        slots: {
            container: sxs.bannerInfoContainer,
            icon: sxs.bannerInfo,
            title: sxs.bannerInfo,
            button: sxs.bannerInfoButton,
        },
        icon: <InfoIcon />,
    },
    WARNING: {
        slots: {
            container: sxs.bannerWarningContainer,
            icon: sxs.bannerWarning,
            title: sxs.bannerWarning,
            button: sxs.bannerWarningButton,
        },
        icon: <InfoIcon />,
    },
    NEUTRAL: {
        slots: {
            container: sxs.bannerNeutralContainer,
            icon: sxs.bannerNeutral,
            title: sxs.bannerNeutral,
            button: sxs.bannerNeutralButton,
        },
        icon: <InfoIcon />,
    },
    ERROR: {
        slots: {
            container: sxs.bannerErrorContainer,
            icon: sxs.bannerError,
            title: sxs.bannerError,
            button: sxs.bannerErrorButton,
        },
        icon: <InfoIcon />,
    },
}
